import { render, staticRenderFns } from "./ShippingLogBLDetailBLContainerPop.vue?vue&type=template&id=0fafcba6"
import script from "./ShippingLogBLDetailBLContainerPop.vue?vue&type=script&lang=js"
export * from "./ShippingLogBLDetailBLContainerPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fafcba6')) {
      api.createRecord('0fafcba6', component.options)
    } else {
      api.reload('0fafcba6', component.options)
    }
    module.hot.accept("./ShippingLogBLDetailBLContainerPop.vue?vue&type=template&id=0fafcba6", function () {
      api.rerender('0fafcba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShippingLogBLDetailBLContainerPop.vue"
export default component.exports